import React from 'react';

type State = { hasError: boolean; error?: any };

export class ChunkErrorBoundary extends React.Component<React.PropsWithChildren, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: any): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: any) {
    const message = String(error?.message || '');
    const isChunkError = /Loading chunk [\d]+ failed/i.test(message) || error?.name === 'ChunkLoadError';

    if (isChunkError) {
      console.warn('ChunkLoadErrorDetected Message={Message}', { Message: message });
      const url = new URL(window.location.href);
      url.searchParams.set('v', Date.now().toString());
      window.location.replace(url.toString());
    } else {
      console.error('UnhandledError Error={Error}', { Error: message });
    }
  }

  render() {
    if (this.state.hasError) return null;
    return this.props.children;
  }
}
